import { useEffect, useState } from 'react';
import { IoChevronUp } from 'react-icons/io5';
import { useSwiper } from 'swiper/react';

export function SlidePrevButton({ controller, disabled = false }) {
	const swiper = useSwiper();
	const [controls, setControls] = useState(controller);

	useEffect(() => {
		setControls(controller)
	}, [controller])

	return (
		<button className='slide-prev' disabled={disabled} onClick={() => controls ? controls.slidePrev() : swiper?.slidePrev()}>
			<IoChevronUp />
		</button>
	);
}